import * as React from "react"

interface IconProps {
  color?: string
}

export const LinkedInIcon: React.FunctionComponent<IconProps> = ({ color = "#fff" }) => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.8571 3H5.13616C3.95759 3 3 3.97098 3 5.16295V30.8371C3 32.029 3.95759 33 5.13616 33H30.8571C32.0357 33 33 32.029 33 30.8371V5.16295C33 3.97098 32.0357 3 30.8571 3ZM12.067 28.7143H7.62054V14.3973H12.0737V28.7143H12.067ZM9.84375 12.442C8.41741 12.442 7.26562 11.2835 7.26562 9.86384C7.26562 8.4442 8.41741 7.28571 9.84375 7.28571C11.2634 7.28571 12.4219 8.4442 12.4219 9.86384C12.4219 11.2902 11.2701 12.442 9.84375 12.442ZM28.7344 28.7143H24.2879V21.75C24.2879 20.0893 24.2545 17.9531 21.9777 17.9531C19.6607 17.9531 19.3058 19.7612 19.3058 21.6295V28.7143H14.8594V14.3973H19.125V16.3527H19.1853C19.7812 15.2277 21.2344 14.0424 23.3973 14.0424C27.8973 14.0424 28.7344 17.0089 28.7344 20.8661V28.7143Z"
      fill={color}
    />
  </svg>
)
